// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"219eb8b1","310":"219eb8b1"}[chunkId] + ".chunk.css";
};